export const statsTabs = [
    { key: 'body', label: 'Body' },
    { key: 'hitting_basic', label: 'Hitting Basic' },
    { key: 'hitting_mechanics', label: 'Hitting Mechanics' },
    { key: 'fielding', label: 'Fielding' },
    { key: 'throwing', label: 'Throwing' },
    { key: 'pitching_basic', label: 'Pitching Basic' },
    { key: 'pitching_type', label: 'Pitching Type' },
  ]